import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import metadataReducer from './slices/metadataSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    metadata: metadataReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types for serializable check
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

// Type definitions for use in components
export const getRootState = () => store.getState();
export const getAppDispatch = () => store.dispatch;
